import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(0).addClass("active");
var swiper = new Swiper(".index-banner .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:2000,
    autoplay: {
        delay: 3000,
    },
    pagination: {
        el: '.index-banner .swiper-pagination',
        clickable: true,
    },
});

// 视频播放
// $(".play").click(function () {
//     var video = document.getElementById('myVideo');
//     if (video.paused) { //如果已暂停则播放
//         $('.play').hide();
//         video.play(); //播放控制
//     } else { // 已播放点击则暂停
//         $('.play').show();
//         video.pause(); //暂停控制
//     }
// })

// tab切换
// $(".culture-nav a").eq(0).addClass("active")
// $(".culture-text li").eq(0).addClass("active");
// $(".culture-nav a").hover(function () {
//     let index = $(this).index();
//     $(this).addClass("active").siblings().removeClass("active");
//     $(".culture-text li").eq(index).addClass("active").siblings().removeClass("active");
// })